import React from "react";
import { Grid, Box, Typography } from "@mui/material";

export default function MenuItem(props) {
  let darkMode = localStorage.getItem("darkMode") === "true" ? true : false;

  return (
    <>
      <Grid
        item
        xs={12}
        sx={{
          minWidth: "100%",
          display: "inline-block",
          color: "#696969",
          backgroundImage: "url(" + (props.icon || "./img/di-edi.png") + ")",
          backgroundSize: "20px",
          backgroundRepeat: "no-repeat",
          backgroundPosition: "5px center",
          paddingLeft: "24px",
          backgroundColor:
            props.selectedItemId === props.itemId
              ? darkMode
                ? "#00000085"
                : "#fff2ed"
              : "unset",
          cursor: "pointer",
          userSelect: "none",
          borderLeft:
            "solid 3px " +
            (props.selectedItemId === props.itemId ? "#ff5722" : "transparent"),
        }}
      >
        <Box m={1}>
          <Typography variant="body2">{props.name}</Typography>
        </Box>
      </Grid>
    </>
  );
}
